import React from 'react';
import { Button, Badge } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { useCart } from '../../contexts/CartContext';

function CartButton() {
    const { getCartItemCount, openCart } = useCart();
    const itemCount = getCartItemCount();

    return (
        <Badge 
            count={itemCount} 
            size="small" 
            offset={[-8, 8]}
            style={{ 
                boxShadow: '0 2px 8px rgba(201, 125, 96, 0.25)'
            }}
        >
            <Button
                type="primary"
                icon={<ShoppingCartOutlined />}
                onClick={openCart}
                className="btn-vibrant h-12 px-6 rounded-lg font-semibold text-base shadow-md hover:shadow-lg transition-all duration-300"
                style={{
                    background: '#C97D60',
                    border: 'none'
                }}
            >
                Cart {itemCount > 0 && `(${itemCount})`}
            </Button>
        </Badge>
    );
}

export default CartButton;
